import Icon from '../Icon'

interface HeaderTitleBackButtonWrapperProps {
    /**
     * Header title
     */
    title?: string
    /**
     * Show back button
     */
    showBackButton?: boolean
    /**
     * Optional icon
     */
    icon?: JSX.Element
    /**
     * On click event
     */
    onClick?: () => void

    totalProducts?: number

    description?: string

    showLiveChip?: string
}

export const HeaderTitleBackButtonWrapper = ({
    title,
    showBackButton = true,
    icon,
    onClick,
    totalProducts,
    description,
    showLiveChip
}: HeaderTitleBackButtonWrapperProps) => {
    const handleClick = () => {
        if (!onClick) {
            return
        }

        onClick()
    }
    return (
        <div

            className="flex items-center rtl:gap-[12px]  mr-2.5 text-neutrals-900">
            {showBackButton && <Icon name="chevron-left" width={32} onClick={() => handleClick()}></Icon>}
            {icon!! && <div className={`${showBackButton && 'ml-2'} flex justify-center items-center`}>{icon}</div>}
            <div className={`flex flex-col  justify-center  items-start ${showBackButton || icon!! ? 'ml-3' : ''}`}>
                <span
                    className={`font-semibold leading-5  flex justify-between items-center   text-neutrals-900 text-[18px] rtl:gap-[12px]`}>
                    {title} {totalProducts ? `(${totalProducts})` : ''}
                    {
                        showLiveChip &&
                        <span className="bg-orange-100 text-orange-600 font-bold text-[12px] ml-2 px-4 py-0.5  my-auto  rounded-full">
                            {showLiveChip}
                        </span>
                    }
                </span>
                {
                    description &&
                    <span className='text-[13px] mt-0.5 text-gray-500'>{description}</span>
                }
            </div>
        </div>
    )
}
